<template>
  <template v-if="(data?.attributes?.slideType === 'fashion-1' || data?.attributes?.slideType === 'fashion-2')">
    <div
      class="promoSlide-item"
      :class="{'hide-for-small-desktop hide-for-medium-only hide-for-small-only' : data?.secondaryImageMap?.attributes?.featuredImage === 'true'}"
    >
      <div
        v-if="data?.attributes?.isLogoPresent === 'true'"
        class="logo hide-for-large-only hide-for-medium-only"
        :class="logoClassObject"
      >
        <PromoSlideshowLogo :logocontext="data" />
      </div>
      <div class="mainImageMap">
        <ImageMap :image-map="data?.primaryImageMap" />
      </div>
    </div>
    <div class="promoSlide-item-copy grid-y">
      <div class="promoSlide-item-copy-container">
        <div class="logo-text-wrapper">
          <div
            v-if="data?.attributes?.isLogoPresent === 'true'"
            class="logo hide-for-small-only"
            :class="logoClassObject"
          >
            <PromoSlideshowLogo :logocontext="data" />
          </div>
          <div class="divider hide-for-small-only" />
          <PromoSlideshowCopy :copy="data" />
        </div>
        <div
          v-if="data?.ctas?.children?.length"
          class="ctas-wrapper"
        >
          <div
            class="ctas-container margin-top-xxs"
            :class="ctasClassObject"
          >
            <Ctas
              :ctas="data?.ctas"
              :alignment="data?.attributes?.alignment"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="promoSlide-item"
      :class="{'hide-for-small-desktop hide-for-medium-only hide-for-small-only' : data?.primaryImageMap?.attributes?.featuredImage === 'true'}"
    >
      <div
        v-if="data?.attributes?.isLogoPresent === 'true'"
        class="logo hide-for-large-only hide-for-medium-only"
        :class="logoClassObject"
      >
        <PromoSlideshowLogo :logocontext="data" />
      </div>
      <div
        v-if="data?.attributes?.isSecondaryImagePresent === 'true'"
        class="mainImageMap"
      >
        <ImageMap :image-map="data?.secondaryImageMap" />
      </div>
    </div>
  </template>
  <template v-if="(data?.attributes?.slideType === 'fashion-3' || data?.attributes?.slideType === 'fashion-4')">
    <div class="promoSlide-item-copy grid-y">
      <div class="promoSlide-item-copy-container">
        <div class="logo-text-wrapper">
          <PromoSlideshowCopy :copy="data" />
        </div>
        <div
          v-if="data?.ctas?.children?.length"
          class="ctas-wrapper"
        >
          <div
            class="ctas-container margin-top-xxs"
            :class="ctasClassObject"
          >
            <Ctas
              :ctas="data?.ctas"
              :alignment="data?.attributes?.alignment"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="promoSlide-item">
      <div
        v-if="data?.attributes?.isLogoPresent === 'true'"
        class="logo"
        :class="logoClassObject"
      >
        <PromoSlideshowLogo :logocontext="data" />
      </div>
      <div class="mainImageMap">
        <ImageMap :image-map="data?.primaryImageMap" />
      </div>
    </div>
  </template>
</template>

<script setup>
import {
  computed,
} from 'vue';
import ImageMap from '../imageMap/ImageMap';
import PromoSlideshowLogo from './PromoSlideshowLogo';
import PromoSlideshowCopy from './PromoSlideshowCopy';
import Ctas from '../ctas';

const props = defineProps({
  data: {
    type: Object,
    default: () => {},
  },
});
const logoClassObject = computed(() => ({
  'logo-middle': props.data?.attributes?.logoPosition === 'middle',
  'logo-top': props.data?.attributes?.logoPosition === 'top',
  'logo-bottom': props.data?.attributes?.logoPosition === 'bottom',
}));
const ctasClassObject = computed(() => ({
  linkClass: props.data?.ctas?.attributes?.linkStyle === 'underlinedText',
  buttonClass: (props.data?.ctas?.attributes?.linkStyle === 'primaryButton' || props.data?.ctas?.attributes?.linkStyle === 'secondaryButton'),
}));
</script>

<style lang="scss" scoped>
  .promoSlide-item-copy {
    .ctas-container.buttonClass {
      :deep(){
        .ctas-cont {
          row-gap: rem-calc(16px);
          column-gap: rem-calc(16px);
        }
      }
    }
    .ctas-container.linkClass {
      :deep(){
        .ctas-cont {
          row-gap: rem-calc(24px);
          column-gap: rem-calc(32px);
        }
      }
    }
  }
  .promo-fashion-1, .promo-fashion-2 {
    .divider {
      width: 1px;
      border: $hr-gray-divider;
    }
  }
  .promo-fashion-4 {
    .ctas-wrapper {
      width: 80%;
    }
  }
  //large 1024->
  @media only screen and (min-width:#{map-get($breakpoints, 'large')}) {
    .hide-for-large-only {
      display: none;
    }
    .promoSlide-item {
      .logo {
        transform: translate(0%, -50%);
        right: rem-calc(80px);
        top: 50%;
      }
    }
    .promoSlide-item-copy {
      flex: 1;
    }
    .promo-fashion-1 {
      position: relative;
      .divider {
        display: none;
      }
      .promoSlide-item {
        width: 50%;
      }
      .promoSlide-item-copy {
        z-index: 1;
        position: absolute;
        width: rem-calc(554px);
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .promoSlide-item-copy-container {
          margin: 0;
          .logo-text-wrapper {
            flex-direction: column;
            align-items: center;
            .copy-container {
              max-width: rem-calc(360px);
              text-align: center;
            }
          }
          .ctas-container {
            justify-content: center;
            :deep(){
              .ctas-cont {
                display: flex;
                justify-content: center;
              }
            }
          }
        }
      }
    }
    .promo-fashion-2 {
      .divider {
        display: none;
      }
      .promoSlide-item {
        width: 33.6%;
      }
      .promoSlide-item-copy {
        width: 33%;
        .promoSlide-item-copy-container {
          margin: 0 rem-calc(68px);
          text-align: center;
          .logo-text-wrapper {
            flex-direction: column;
            align-items: center;
          }
          .copy-container {
            align-content: center;
          }
          .ctas-container {
            justify-content: center;
            :deep() {
              .ctas-cont {
                justify-content: center;
              }
            }
          }
        }
      }
    }
    .promo-fashion-3 {
      .promoSlide-item-copy, .promoSlide-item {
        width: 50%;
      }
    }
    .promo-fashion-4 {
      .promoSlide-item-copy {
        width: 50%;
        height: inherit;
        position: absolute;
        z-index: 1;
        top: 50%;
        transform: translate(0%, -50%);
      }
      .promoSlide-item {
        width: 100%;
      }
    }
    .promo-fashion-3, .promo-fashion-4 {
      .promoSlide-item-copy {
        margin: 0 rem-calc(64px);
        .promoSlide-item-copy-container .logo-text-wrapper {
          width: 80%;
        }
      }
    }
  }
//Tablet 600->1023
@media screen and (min-width: #{map-get($breakpoints, 'medium')}) and (max-width: #{map-get($breakpoints, 'large')-1}) {
  .hide-for-small-desktop {
    display: none;
  }
  .promoSlide-item-copy-container {
    margin: 0 rem-calc(32px);
  }
  .promoSlide-item {
    .mainImageMap {
      max-height: rem-calc(540px);
      width: 100%;
    }
    .logo {
      right: rem-calc(32px);
      top: 50%;
      transform: translate(0%, -50%);
    }
  }
  .promoSlide-item-copy {
    flex: 1;
  }
  .promo-fashion-3, .promo-fashion-1, .promo-fashion-2 {
    .promoSlide-item {
      max-width: 43%;
      width: -webkit-fill-available;
      width: -moz-available;
    }
  }
  .promo-fashion-1, .promo-fashion-2 {
    .promoSlide-item {
      order: 1;
    }
  }
  .promo-fashion-4 {
    .promoSlide-item {
      position: relative;
      width: 100%;
    }
    .promoSlide-item-copy {
      position: absolute;
      z-index: 1;
      width: 59%;
      height: inherit;
    }
  }
}
//small 0->599
@media only screen and (max-width:#{map-get($breakpoints, 'medium')-1}) {
  .promo-fashion-1, .promo-fashion-2, .promo-fashion-3, .promo-fashion-4 {
    .promoSlide-item-copy {
      margin: rem-calc(16px) rem-calc(20px) 0 rem-calc(20px);
      order: 1;
      .promoSlide-item-copy-container {
        margin: 0;
        .logo-text-wrapper {
          display: block;
          width: 80%;
        }
      }
    }
    .promoSlide-item {
      .logo {
        left: rem-calc(20px);
        z-index: 1;
      }
      .logo-bottom {
        bottom: rem-calc(20px);
      }
      .logo-top {
        top: rem-calc(20px);
      }
      .logo-middle {
        top: 50%;
        transform: translate(0%, -50%)
      }
      .mainImageMap {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss" brand="mcom">
@import './../../scss/globalAttributes.mcom.scss';
</style>

<style lang="scss" brand="bcom" scoped>
@import './../../scss/globalAttributes.bcom.scss';
</style>
